import dayjs from 'utils/dayjs';

import { periodsInNum } from 'constants/currency';

import {
  DEFAULT_API_DATE_FORMAT,
  DEFAULT_CLIENT_DATE_FORMAT,
  DEFAULT_MOBILE_DATE_FORMAT,
  DEFAULT_TIMESTAMP_FORMAT,
} from './defaultValues';

const STRING_DATE_FORMATS = [
  DEFAULT_MOBILE_DATE_FORMAT,
  DEFAULT_TIMESTAMP_FORMAT,
  DEFAULT_CLIENT_DATE_FORMAT,
  'YYYY-MM-DD HH:mm',
  DEFAULT_API_DATE_FORMAT,
  'DD.MM.YYYY HH:mm:ss',
  'DD.MM.YYYY HH:mm',
  'DD.MM.YYYY',
];

export const parseDate = value => {
  if (value == null || value === '') {
    return null;
  }

  if (dayjs.isDayjs(value)) {
    return value.isValid() ? value : null;
  }

  if (value instanceof Date) {
    const parsed = dayjs(value);

    return parsed.isValid() ? parsed : null;
  }

  if (typeof value === 'number') {
    const parsed = dayjs(value);

    return parsed.isValid() ? parsed : null;
  }

  if (typeof value !== 'string') {
    const parsed = dayjs(value);

    return parsed.isValid() ? parsed : null;
  }

  const trimmed = value.trim();
  const parsedFromFormat = STRING_DATE_FORMATS.reduce((result, format) => {
    if (result) {
      return result;
    }

    const parsed = dayjs(trimmed, format, true);

    return parsed.isValid() ? parsed : null;
  }, null);

  if (parsedFromFormat) {
    return parsedFromFormat;
  }

  const isoParsed = dayjs(trimmed);

  return isoParsed.isValid() ? isoParsed : null;
};

export const formatParsedDate = (value, format, locale) => {
  const parsed = parseDate(value);

  if (!parsed) {
    return '';
  }

  const localized = locale ? parsed.locale(locale) : parsed;

  return localized.format(format);
};

export const getDate = (date, period) => {
  const parsed = parseDate(date);

  if (!parsed) {
    return {};
  }

  const dateFrom = parsed
    .clone()
    .subtract(Math.floor(periodsInNum[period] / 2), 'days')
    .format(DEFAULT_MOBILE_DATE_FORMAT);

  const dateTo = parsed
    .clone()
    .add(Math.ceil(periodsInNum[period] / 2), 'days')
    .format(DEFAULT_MOBILE_DATE_FORMAT);

  const isAfter = dayjs().isBefore(dateTo);

  return {
    dateFrom,
    dateTo: isAfter ? dayjs().format(DEFAULT_MOBILE_DATE_FORMAT) : dateTo,
  };
};

export default getDate;
